import { createSlice } from '@reduxjs/toolkit';

export const utmSourceSlice = createSlice({
  name: 'utmSource',
  initialState: null as string | null,
  reducers: {},
});

export const { reducer: utmSourceReducer } = utmSourceSlice;
